export default __webpack_public_path__ + "static/media/plus.5ac1a03a.svg";